module.exports = __webpack_public_path__ + "static/img/analysis_item_1.5cac20a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/analysis_item_1.png
// module id = FQJX
// module chunks = 34